import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { addParamsToUrl, getQueryStringParams } from 'shared/dist/utils/url';
import auth, { callbackURL } from './lib/auth';
// data containers
import User from './data-containers/user';
import URLState from './data-containers/url-state';
import Fleets from './data-containers/fleets';
// components
import DashboardPage from './components/pages/dashboard';
import EnergyProjectionsPage from './components/pages/energy-projections';
import ErrorPage from './components/pages/error';
import NotFoundPage from './components/pages/not-found';
import LoadingSpinner from './components/atoms/loading-spinner';
import EulaModal from './components/modals/eula';

const defaultRoute = '/dashboard';
// const defaultRoute = '/energy-projections';

const indexRedirect = function(){
  return <Redirect push={true} to={defaultRoute} />;
};

const goToLoginPage = function(){
  let params = {
    redirect_uri: callbackURL()
  };
  if(auth.clientId){
    params.client_id = auth.clientId;
  }
  if(auth.domain){
    params.domain = auth.domain;
  }
  window.location.href = addParamsToUrl(params, callbackURL('/login'));
  return null;
}

const receiveToken = function(props){
  auth.processAuthHash(props.location.hash);
  try {
    const { entry } = getQueryStringParams();
    if(entry){
      return (<Redirect to={entry} />);
    }
    return indexRedirect();  
  }
  catch(err){
    console.error(err);
    indexRedirect();
  }
};

const logout = function(){
  if(auth.loggedIn()){
    auth.logout(); 
  }
  else {
    goToLoginPage();
  }
  return null;
}

const authenticatedRoutes = function(props) {
  if(!auth.loggedIn()){
    return goToLoginPage();
  }

  const MainContent = function(props){
    const { match, location } = props;
    const { fleets } = Fleets.useContainer();
    const { fleetId } = URLState.useContainer();
    let { loading, error, userDetail } = User.useContainer();

    if(error){
      console.error(error);
      return (
        <ErrorPage {...error} />
      );
    }

    if(!loading){
      let defaultFleet = fleets.find(f => f.id === userDetail.provider) || fleets[0];
      
      if(!defaultFleet){
        return (
          <ErrorPage statusCode={400} message="You do not have access to any Curb fleets" />
        );
      }

      if(!fleetId){
        return <Redirect push={true} to={`/${defaultFleet.id}`} />
      }

      let matchingFleet = fleets.find(f => f.id === fleetId);

      if(!matchingFleet){
        return (
          <Redirect push={true} to={location.pathname.replace(new RegExp(`^/${fleetId}`, 'ig'), defaultFleet.id)} />
        );
      }

    }

    return loading
      ? <div className="application-loader">
          <LoadingSpinner />
          <p className="application-loader-message">Loading application state</p>
        </div>   
      : (!userDetail.accepted_eula)
        ? <EulaModal />
        : <Switch>
          <Route exact path={`${match.url}/energy-projections`} component={EnergyProjectionsPage} />
          <Route exact path={`${match.url}/dashboard`} component={DashboardPage} />
          {/* when navigating just to url */}
          <Route exact path={match.url} render={() => <Redirect to={`${match.url}${defaultRoute}`} />} />
          <Route path="*" component={NotFoundPage} />
        </Switch>;
  }

  return (
    <Fleets.Provider>
      <URLState.Provider initialState={props}>
        <User.Provider initialState={ { loading: true, user: {}, fleets: [], userDetail: {} } }>
            <MainContent {...props} />
        </User.Provider>
      </URLState.Provider>
    </Fleets.Provider>
  );
}

const AppRouter = () => (
  <Router>
    <Switch>
      <Route path='/token' render={receiveToken} />
      <Route path='/logout' render={logout} />
      <Route exact path='/' render={indexRedirect} />
      <Route path="/:fleetId?/all" render={withRouter(authenticatedRoutes)} />
      <Route path="/:fleetId?" render={withRouter(authenticatedRoutes)} />
    </Switch>
  </Router>
);

export default AppRouter;
